import { toast } from "sonner";
import { Copy } from "lucide-react";
import { API } from "@/lib/api";

const site = window.location.origin;

const Snippet = ({ label, code, id }) => (
  <div className="border border-[#E5DACA] rounded-lg bg-white p-5">
    <div className="flex items-center justify-between">
      <p className="eyebrow">{label}</p>
      <button type="button" onClick={() => { navigator.clipboard.writeText(code); toast.success("Copied"); }} data-testid={`copy-${id}`}
        className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-[#A8832F] hover:text-[#8C6A22]"><Copy className="h-3.5 w-3.5" />Copy</button>
    </div>
    <pre className="mt-3 overflow-x-auto whitespace-pre-wrap break-all font-mono text-xs text-[#4A423A]" data-testid={`snippet-${id}`}>{code}</pre>
  </div>
);

export const AdminEmbed = ({ events }) => (
  <div className="mt-6 space-y-4" data-testid="admin-embed">
    <p className="max-w-2xl text-sm text-[#6B6157]">Use these on your main website to show live dates and send guests here to book. Seat counts update automatically.</p>
    <Snippet id="all-iframe" label="Widget: all events" code={`<iframe src="${site}/embed" style="width:100%;height:520px;border:0" title="Bourbon events"></iframe>`} />
    {events.filter((e) => e.published).map((e) => (
      <Snippet key={e.id} id={`iframe-${e.slug}`} label={`Widget: ${e.title}`} code={`<iframe src="${site}/embed/${e.slug}" style="width:100%;height:420px;border:0" title="${e.title}"></iframe>`} />
    ))}
    <Snippet id="api" label="JSON feed (for your developer)" code={`GET ${API}/v1/events\nGET ${API}/v1/events/{slug}`} />
  </div>
);
